const jobItemBorderClasses = (item, reference, total) => {
   const mediumLeft = 'job-item-border__medium__left';
   const largeLeft = 'job-item-border__large__left';
   const smallBottom = 'job-item-border__small__bottom';
   const mediumBottom = 'job-item-border__medium__bottom';
   const largeBottom = 'job-item-border__large__bottom';

   const mediumColumnCount = 2;
   const largeColumnCount = 3;

   item.classList.remove('hidden');
   item.classList.remove(mediumLeft);
   item.classList.remove(largeLeft);
   item.classList.remove(smallBottom);
   item.classList.remove(mediumBottom);
   item.classList.remove(largeBottom);
   item.style.order = reference;

   if (reference % mediumColumnCount === 1) {
      item.classList.add(mediumLeft);
   }

   if (reference % largeColumnCount === 1) {
      item.classList.add(largeLeft);
   }

   const bottomAmountCalculation = ((amount, rowAmount) => {
      return (amount - (amount - ((Math.floor(amount / rowAmount)) * rowAmount)));
   });

   let mediumBottomAmount = bottomAmountCalculation(total, mediumColumnCount);
   let largeBottomAmount = bottomAmountCalculation(total, largeColumnCount);

   if (total % mediumColumnCount === 0) {
      mediumBottomAmount = mediumBottomAmount - mediumColumnCount;
   }

   if (total % largeColumnCount === 0) {
      largeBottomAmount = largeBottomAmount - largeColumnCount;
   }

   if (reference === total) {
      item.classList.add(smallBottom);
   }

   if (reference > mediumBottomAmount) {
      item.classList.add(mediumBottom);
   }

   if (reference > largeBottomAmount) {
      item.classList.add(largeBottom);
   }
};

export default jobItemBorderClasses;